import HomeIcon from '@mui/icons-material/Home'
import PersonIcon from '@mui/icons-material/Person'

export const bottomMenus = [
  {
    label: 'Home',
    value: 'home',
    icon: <HomeIcon />,
  },
  {
    label: 'User',
    value: 'user',
    icon: <PersonIcon />,
  },
]
